export default __webpack_public_path__ + "static/media/cabletv.f9abcfd4.svg";